module.exports = __webpack_public_path__ + "img/invited.389e1276.svg";